import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import CEProductCustomizationButton from './CEProductCustomizationButton.jsx';

const mountProductCustomizationButtons = () => {
  const elements = document.querySelectorAll('.product-customization-button-react');

  if (!elements.length) return;

  elements.forEach((element) => {
    if (!element || element.dataset.reactMounted === 'true') return;
    element.dataset.reactMounted = 'true';

    const storeName = element.getAttribute('data-store-name') || 'shared';
    const language = element.getAttribute('data-language') || 'it';
    const drawerId = element.getAttribute('data-drawer-id') || 'product-customization-drawer';
    const buttonText = element.getAttribute('data-customization-button-text') || 'Customize';

    createRoot(element).render(
      <StrictMode>
        <CEProductCustomizationButton
          storeName={storeName}
          language={language}
          drawerId={drawerId}
          buttonText={buttonText}
        />
      </StrictMode>,
    );
  });
};

mountProductCustomizationButtons();
window.mountProductCustomizationButtons = mountProductCustomizationButtons;
